import MobileAuthButtons from './MobileAuthButtons';

type MobileMenuProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null;

  return (
    <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 mt-0">
      <div className="px-4 py-4 space-y-4">
        <MobileAuthButtons onClose={onClose} />
      </div>
    </div>
  );
}
